export const getReviewDate = (date) => {
  if (!date) {
    return ''
  }

  const dateStamp = new Date(date)

  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }).format(dateStamp)
}
